var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 36,
    viewBox: "0 0 47 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9458 18.6238C37.1812 18.6892 37.4325 18.666 37.6519 18.5585C37.8714 18.451 38.0438 18.2668 38.1365 18.0407C38.2292 17.8146 38.2357 17.5623 38.1549 17.3317C38.074 17.1011 37.9114 16.9082 37.6978 16.7895L35.5791 14.3857L33.7871 14.7729L36.3075 17.2417C36.2456 17.3729 36.2131 17.5162 36.2125 17.6613C36.2119 17.8065 36.2431 17.95 36.304 18.0817C36.3648 18.2135 36.4538 18.3303 36.5647 18.424C36.6756 18.5176 36.8057 18.5858 36.9458 18.6238Z",
    fill: "url(#paint0_linear_1813_120599)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9756 10.0179L35.2562 16.6466L36.8659 15.9075L30.6591 6.24414L29.9756 10.0179Z",
    fill: "url(#paint1_linear_1813_120599)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5313 35.4719C17.8512 35.4719 18.1105 35.2126 18.1105 34.8927C18.1105 34.5728 17.8512 34.3135 17.5313 34.3135C17.2115 34.3135 16.9521 34.5728 16.9521 34.8927C16.9521 35.2126 17.2115 35.4719 17.5313 35.4719Z",
    fill: "url(#paint2_linear_1813_120599)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9514 23.2292C17.9514 23.2292 19.3204 19.0695 19.4257 18.7799C19.531 18.4903 20.6367 18.9642 20.9263 19.0432C21.2159 19.1221 21.1369 19.4118 21.1369 19.4118L19.6626 23.6768L20.1102 23.8874L21.4791 19.596C22.2689 18.7799 21.6898 18.7272 21.6898 18.7272C21.6898 18.7272 20.0049 18.148 19.373 18.0954C18.7412 18.0427 18.9781 18.8062 18.9781 18.8062L17.4512 22.8606L17.9514 23.2292Z",
    fill: "url(#paint3_linear_1813_120599)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2425 24.2299L21.2423 24.2297C21.048 23.9511 20.7722 23.7397 20.4528 23.6244C20.4414 23.6202 20.4283 23.6155 20.4133 23.6102C19.688 23.3567 14.6346 21.9921 14.6346 21.9921C14.6346 21.9921 13.6342 21.6235 13.1866 22.624C12.7391 23.6244 10.0801 31.9176 10.0801 31.9176C10.0801 31.9176 15.2806 34.6988 16.7968 35.0016C16.8904 35.0241 16.987 35.0317 17.0829 35.0242C17.3407 34.9885 17.5943 34.9279 17.8404 34.8433C18.1125 34.7546 18.3714 34.6295 18.6099 34.4713L21.5585 25.6516C21.5585 25.6516 21.9797 24.6775 21.2425 24.2299Z",
    fill: "url(#paint4_linear_1813_120599)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2436 24.2301L21.2434 24.2298C21.0491 23.9513 20.7733 23.7398 20.4538 23.6246C20.4425 23.6203 20.4293 23.6156 20.4143 23.6104C20.6529 24.0284 20.7434 24.6777 20.7434 24.6777C20.7434 24.6777 17.8475 33.2867 17.5842 34.1029C17.3836 34.725 16.979 34.9364 16.7979 35.0017C16.8915 35.0243 16.988 35.0319 17.084 35.0243C17.3417 34.9886 17.5954 34.928 17.8414 34.8435C17.9134 34.761 17.9771 34.6717 18.0318 34.5768C18.0318 34.5768 20.9804 25.7571 21.2436 25.3358C21.5069 24.9146 21.2436 24.2301 21.2436 24.2301Z",
    fill: "url(#paint5_linear_1813_120599)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.754 35.4846C16.0739 35.4846 16.3332 35.2253 16.3332 34.9054C16.3332 34.5855 16.0739 34.3262 15.754 34.3262C15.4341 34.3262 15.1748 34.5855 15.1748 34.9054C15.1748 35.2253 15.4341 35.4846 15.754 35.4846Z",
    fill: "url(#paint6_linear_1813_120599)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1319 33.049C10.4518 33.049 10.7111 32.7897 10.7111 32.4698C10.7111 32.1499 10.4518 31.8906 10.1319 31.8906C9.81205 31.8906 9.55273 32.1499 9.55273 32.4698C9.55273 32.7897 9.81205 33.049 10.1319 33.049Z",
    fill: "url(#paint7_linear_1813_120599)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3424 19.1336C20.1094 19.2074 19.8575 19.1931 19.6344 19.0935C19.4112 18.994 19.2323 18.816 19.1317 18.5933C19.031 18.3707 19.0154 18.1188 19.088 17.8855C19.1606 17.6521 19.3163 17.4535 19.5255 17.3273L21.5572 14.8496L23.3619 15.1727L20.931 17.7297C20.9976 17.8586 21.0351 18.0006 21.0409 18.1457C21.0467 18.2907 21.0206 18.4352 20.9645 18.5691C20.9083 18.7029 20.8236 18.8229 20.7161 18.9204C20.6086 19.0179 20.481 19.0907 20.3424 19.1336Z",
    fill: "url(#paint8_linear_1813_120599)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1895 30.0344L35.448 30.0146L35.2966 34.3043H34.1897L34.1895 30.0344Z",
    fill: "url(#paint9_linear_1813_120599)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9062 33.9444L36.0863 33.9443H36.0864C36.4548 33.9444 36.8082 34.0907 37.0687 34.3513C37.3293 34.6118 37.4757 34.9652 37.4757 35.3337V35.3788L33.9063 35.3789L33.9062 33.9444Z",
    fill: "url(#paint10_linear_1813_120599)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8566 28.8965L27.2314 29.7791L24.4813 33.0877L23.5498 32.4896L25.8566 28.8965Z",
    fill: "url(#paint11_linear_1813_120599)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5064 32.0322L25.3409 33.21L25.341 33.2101C25.651 33.4092 25.8693 33.7233 25.9478 34.0833C26.0263 34.4433 25.9585 34.8197 25.7595 35.1298L25.7351 35.1678L22.7314 33.2394L23.5064 32.0322Z",
    fill: "url(#paint12_linear_1813_120599)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3662 15.7987C25.3662 15.7987 28.4208 5.65283 29.4025 5.51572C30.3842 5.37861 31.9659 8.11904 31.9659 8.11904C34.0167 10.7356 36.1313 19.2114 36.1313 19.2114C36.1313 19.2114 32.6061 19.432 30.0292 20.8031C27.4523 22.1742 24.4111 20.7337 24.4111 20.7337L25.3662 15.7987Z",
    fill: "url(#paint13_linear_1813_120599)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.3662 15.7987C25.3662 15.7987 28.4208 5.65278 29.4025 5.51567C30.3842 5.37857 31.5642 8.1468 31.5642 8.1468C32.586 12.3706 36.1313 19.2114 36.1313 19.2114C36.1313 19.2114 32.6061 19.432 30.0292 20.8031C27.4523 22.1741 24.4111 20.7336 24.4111 20.7336L25.3662 15.7987Z",
    fill: "url(#paint14_linear_1813_120599)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8728 12.761V17.8592L27.2729 25.2444L24.2754 30.8308L25.706 31.8527L29.7935 26.5388L31.4101 21.2625L33.949 32.9427L35.8565 32.8064L34.5318 16.612L32.0179 12.0537L27.8728 12.761Z",
    fill: "url(#paint15_linear_1813_120599)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9539 7.82997C31.9076 8.78374 31.022 9.80563 31.022 9.80563L32.112 12.2582L27.8202 13.4163L26.3203 6.71418L27.3422 5.62415C29.3859 5.55603 29.387 5.51367 29.387 5.51367C29.7451 5.8641 30.9539 7.82997 30.9539 7.82997Z",
    fill: "url(#paint16_linear_1813_120599)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1225 6.03949C25.7677 6.30044 25.5189 6.68052 25.4216 7.11006C25.3243 7.5396 25.385 7.98983 25.5927 8.37821C26.0844 9.31684 26.6133 10.7708 26.3406 12.367C25.8471 15.2557 24.2651 17.4504 23.3839 18.1553C23.0771 18.4006 23.0664 18.758 23.1114 19.0145C23.2372 19.7312 23.9321 20.5446 24.4127 20.7076C24.4451 20.7183 24.479 20.7237 24.5131 20.7234C25.2939 20.7237 27.2147 18.2367 29.4218 13.3786C30.7964 10.3531 29.7987 7.9272 28.7198 6.42487C28.5782 6.22829 28.3989 6.06178 28.1925 5.93497C27.9861 5.80815 27.7565 5.72356 27.5171 5.68609C27.2778 5.64863 27.0334 5.65903 26.798 5.71669C26.5627 5.77435 26.3412 5.87814 26.1463 6.02203L26.1225 6.03949Z",
    fill: "url(#paint17_linear_1813_120599)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1594 8.96384L21.9612 17.0967L20.3262 16.4154L26.1849 6.53711L28.1594 8.96384Z",
    fill: "url(#paint18_linear_1813_120599)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9972 4.6321H25.7341C25.6464 4.63201 25.5623 4.59712 25.5003 4.53511C25.4383 4.4731 25.4034 4.38903 25.4033 4.30133V2.46371C25.4032 2.14023 25.4667 1.81989 25.5904 1.52099C25.7141 1.22208 25.8954 0.950476 26.1241 0.721683C26.3527 0.492889 26.6242 0.311393 26.9231 0.187564C27.2219 0.0637348 27.5422 0 27.8657 0C28.1891 0 28.5094 0.0637348 28.8083 0.187564C29.1071 0.311393 29.3786 0.492889 29.6073 0.721683C29.8359 0.950476 30.0173 1.22208 30.1409 1.52099C30.2646 1.81989 30.3282 2.14023 30.328 2.46371V4.30133C30.3279 4.38903 30.293 4.4731 30.231 4.53511C30.169 4.59712 30.0849 4.63201 29.9972 4.6321Z",
    fill: "url(#paint19_linear_1813_120599)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9559 3.65073C30.4342 2.77584 30.1127 1.6789 29.2378 1.20065C28.3629 0.722394 27.266 1.04393 26.7878 1.91881C26.3096 2.7937 26.6311 3.89063 27.5059 4.36889C28.3808 4.84714 29.4777 4.52561 29.9559 3.65073Z",
    fill: "url(#paint20_linear_1813_120599)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9116 2.64772H28.3048L28.278 2.27345L28.1444 2.64772H27.743L27.69 1.90592L27.4251 2.64772H26.6484V2.61097C26.649 2.09454 26.8544 1.59942 27.2196 1.23425C27.5847 0.869079 28.0798 0.663669 28.5962 0.663086H28.9638C29.4802 0.663669 29.9753 0.869078 30.3404 1.23425C30.7056 1.59942 30.911 2.09453 30.9116 2.61097V2.64772Z",
    fill: "url(#paint21_linear_1813_120599)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2818 4.97433C28.2622 4.97431 28.2426 4.97259 28.2233 4.96917L26.3145 4.63236V1.47754H28.4157L28.3637 1.53819C27.6399 2.38235 28.1852 3.75117 28.5746 4.49196C28.6033 4.54621 28.6161 4.60748 28.6116 4.66869C28.607 4.7299 28.5852 4.78857 28.5487 4.83795C28.5182 4.88017 28.4781 4.91455 28.4317 4.93826C28.3853 4.96197 28.3339 4.97433 28.2818 4.97433Z",
    fill: "url(#paint22_linear_1813_120599)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.4831C0 35.4078 0.00576999 35.3356 0.0160407 35.2824C0.0263114 35.2291 0.0402416 35.1992 0.0547665 35.1992H46.4968C46.5113 35.1992 46.5253 35.2291 46.5355 35.2824C46.5458 35.3356 46.5516 35.4078 46.5516 35.4831C46.5516 35.5584 46.5458 35.6306 46.5355 35.6838C46.5253 35.737 46.5113 35.7669 46.4968 35.7669H0.0547665C0.0402416 35.7669 0.0263114 35.737 0.0160407 35.6838C0.00576999 35.6306 0 35.5584 0 35.4831Z",
    fill: "url(#paint23_linear_1813_120599)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1813_120599",
    x1: 32.8843,
    y1: 18.6283,
    x2: 39.4095,
    y2: 18.2117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1813_120599",
    x1: 28.5695,
    y1: 16.569,
    x2: 38.7568,
    y2: 16.1527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1813_120599",
    x1: 16.7158,
    y1: 35.4632,
    x2: 18.4248,
    y2: 35.3578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1813_120599",
    x1: 16.5444,
    y1: 23.8442,
    x2: 23.1102,
    y2: 23.5336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1813_120599",
    x1: 7.71317,
    y1: 34.9293,
    x2: 24.8387,
    y2: 33.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1813_120599",
    x1: 15.8667,
    y1: 34.942,
    x2: 22.62,
    y2: 34.7755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1813_120599",
    x1: 14.9384,
    y1: 35.4759,
    x2: 16.6474,
    y2: 35.3705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1813_120599",
    x1: 9.31634,
    y1: 33.0404,
    x2: 11.0254,
    y2: 32.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1813_120599",
    x1: 18.1616,
    y1: 19.1479,
    x2: 24.5337,
    y2: 18.7559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1813_120599",
    x1: 33.9326,
    y1: 34.2723,
    x2: 35.7959,
    y2: 34.2386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1813_120599",
    x1: 33.1778,
    y1: 35.3682,
    x2: 38.3424,
    y2: 34.5755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1813_120599",
    x1: 22.7985,
    y1: 33.0564,
    x2: 28.2348,
    y2: 32.7618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1813_120599",
    x1: 22.0686,
    y1: 35.1444,
    x2: 26.8595,
    y2: 34.8382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1813_120599",
    x1: 22.0193,
    y1: 21.2765,
    x2: 39.3407,
    y2: 20.4881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1813_120599",
    x1: 22.0193,
    y1: 21.2764,
    x2: 39.3407,
    y2: 20.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1813_120599",
    x1: 21.912,
    y1: 32.7869,
    x2: 39.0433,
    y2: 32.2009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1813_120599",
    x1: 25.1384,
    y1: 13.3574,
    x2: 33.6982,
    y2: 12.9704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1813_120599",
    x1: 21.6633,
    y1: 20.6111,
    x2: 32.0213,
    y2: 20.3141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1813_120599",
    x1: 18.7276,
    y1: 17.0179,
    x2: 30.3041,
    y2: 16.4882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1813_120599",
    x1: 24.3983,
    y1: 4.59755,
    x2: 31.6604,
    y2: 4.12125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1813_120599",
    x1: 28.713,
    y1: 5.86848,
    x2: 30.9798,
    y2: 1.03662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1813_120599",
    x1: 25.7784,
    y1: 2.63291,
    x2: 31.9831,
    y2: 1.8107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1813_120599",
    x1: 25.8455,
    y1: 4.94825,
    x2: 29.2432,
    y2: 4.8105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1813_120599",
    x1: -9.5,
    y1: 35.7627,
    x2: -6.90705,
    y2: 22.6463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaSectionIcon);
export default __webpack_public_path__ + "static/media/visa-section-icon.885e6bb747094c04170eefe8471df1aa.svg";
export { ForwardRef as ReactComponent };